import React, { useState } from "react";
import Layout from "../components/Layout";
import StuTable from "../components/StuTable";
import { ColumnProps } from "antd/lib/table/interface";
import useRequest from "../../../../utils/useRequest";
import {
    getNotJoinExamPeopleList,
    NotJoinExamPeopleItem
} from "../../../../service/exam";
import InvigilationProvider from "../context";
import { isTrue } from "../../../../service/service";

export default function NotTakingExam() {
    const [examId, setExamId] = useState("");
    const [studentName, setStudentName] = useState("");

    const [data, { loading }, refresh] = useRequest(
        () => getNotJoinExamPeopleList({ studentName, examId }),
        {},
        [examId, studentName]
    );

    const columns: ColumnProps<NotJoinExamPeopleItem>[] = [
        {
            title: "参与状态",
            dataIndex: "examFlag",
            align: "center",
            render: examFlag => (isTrue(examFlag) ? "已参与" : "未参与")
        }
    ];

    return (
        <InvigilationProvider
            examList={data?.conditionQueryList || []}
            dataSource={data?.dataList || []}
            examId={examId}
            setExamId={setExamId}>
            <Layout
                title="未参考人员监测"
                refresh={refresh}
                table={
                    <StuTable
                        onErrChange={refresh}
                        columns={columns}
                        loading={loading}
                        buttonShow={[true, false, true, false]}
                        dataSource={data?.dataList || []}
                    />
                }
                onSearch={setStudentName}
            />
        </InvigilationProvider>
    );
}
